export default __webpack_public_path__ + "static/media/img-supervisor.8f3449ef.jpg";